export interface IFaceFrame {
    file: string;
    delayMs: number;
}

export interface IFaceExpression {
    index: number;
    name: string;
    faceId: number;
}

//  Naming-convention magic (MAFaceAniBase.cpp:141-144): the mask texture name is
//  the diffuse name with "_AvatarFace" inserted before the extension.
//  "Wa_Head01.dds" -> "Wa_Head01_AvatarFace.dds". No extension -> unchanged.
export function deriveMaskName(diffuseFile: string): string {
    if (!diffuseFile) {
        return diffuseFile;
    }

    const dot = diffuseFile.lastIndexOf(".");
    if (dot < 0) {
        return diffuseFile;
    }

    return diffuseFile.slice(0, dot) + "_AvatarFace" + diffuseFile.slice(dot);
}

//  Enumerate an actorfacetable row's _Name{i}/_FaceID{i} (i = 1..50); keep only
//  entries with a nonzero FaceID (a 0/absent FaceID means "no expression here").
export function readExpressions(row: Record<string, any>): IFaceExpression[] {
    const out: IFaceExpression[] = [];
    for (let i = 1; i <= 50; i++) {
        const faceId = Number(row["_FaceID" + i]);
        if (faceId) {
            out.push({ index: i, name: String(row["_Name" + i] || ""), faceId });
        }
    }

    return out;
}

//  Enumerate a faceanimationtable row's frames: _TextureName{k}_file (the
//  fileresolve-produced filename) + _Delay{k}, for k = 1..min(_TotalFrame, 28).
//  Stops at the first slot with no resolved filename.
export function readFrames(row: Record<string, any>): IFaceFrame[] {
    const out: IFaceFrame[] = [];
    const total = Number(row["_TotalFrame"]) > 0 ? Number(row["_TotalFrame"]) : 28;
    const bound = Math.min(total, 28);
    for (let k = 1; k <= bound; k++) {
        const file = row["_TextureName" + k + "_file"];
        if (!file) {
            break;
        }

        out.push({ file: String(file), delayMs: Number(row["_Delay" + k]) });
    }

    return out;
}
